// extracted by mini-css-extract-plugin
export default {"root":"GenericErrorWidget_root__D3EnW","error":"GenericErrorWidget_error__rKvjM","warning":"GenericErrorWidget_warning__KNL8k","closeButton":"GenericErrorWidget_closeButton__P7NSU"};